import { type WorkspaceAgentPanelFloatRect } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentPanelFloatRect';
import { clampWorkspaceAgentPanelHeight } from '~/components/v2/components/workspace/workspace-agent-panel/utils/clampWorkspaceAgentPanelHeight';
import {
  getWorkspaceAgentPanelFloatMaxLeft,
  getWorkspaceAgentPanelFloatWidthViewportBound,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentPanelFloatHorizontalBounds';
import { clampWorkspaceAgentPanelWidth } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';
import { WORKSPACE_PANEL_EDGE_PADDING } from '~/constants/panelWidths';

export type ClampWorkspaceAgentPanelFloatRectParams = WorkspaceAgentPanelFloatRect & {
  viewportHeight: number;
  viewportWidth: number;
};

export const clampWorkspaceAgentPanelFloatRect = ({
  height,
  left,
  top,
  viewportHeight,
  viewportWidth,
  width,
}: ClampWorkspaceAgentPanelFloatRectParams): WorkspaceAgentPanelFloatRect => {
  const nextWidth = clampWorkspaceAgentPanelWidth(width, getWorkspaceAgentPanelFloatWidthViewportBound(viewportWidth));
  const nextHeight = clampWorkspaceAgentPanelHeight(height, viewportHeight);
  const maxLeft = getWorkspaceAgentPanelFloatMaxLeft(viewportWidth, nextWidth);
  const maxTop = viewportHeight - nextHeight;

  return {
    height: nextHeight,
    left: Math.min(Math.max(WORKSPACE_PANEL_EDGE_PADDING, left), Math.max(WORKSPACE_PANEL_EDGE_PADDING, maxLeft)),
    top: Math.min(Math.max(0, top), Math.max(0, maxTop)),
    width: nextWidth,
  };
};
